import { render, staticRenderFns } from "./form-reviews.vue?vue&type=template&id=64565f0c&"
import script from "./form-reviews.vue?vue&type=script&lang=js&"
export * from "./form-reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-reviews.vue
// module id = 1017
// module chunks = 0